import React from 'react';
import styleHelper from '@client/shared/styles/styleHelper.scss';

function RecaptchaConditions() {
  return (
    <p>
      Denna sida är skyddad av reCAPTCHA och Google{' '}
      <a
        className={styleHelper.linkPrimary}
        href="https://www.google.com/intl/sv/policies/privacy/"
      >
        Integritetspolicy
      </a>{' '}
      och{' '}
      <a
        className={styleHelper.linkPrimary}
        href="https://www.google.com/intl/sv/policies/terms/"
      >
        servicevillkor
      </a>
      {'.'}
    </p>
  );
}

export default RecaptchaConditions;
